/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1FeedbackFeedbackidLangs202,
  PostApiV1FeedbackFeedbackidLangs400,
  PostApiV1FeedbackFeedbackidLangs401,
  PostApiV1FeedbackFeedbackidLangs404,
  PostApiV1FeedbackFeedbackidLangs409,
  PostApiV1FeedbackFeedbackidLangs500,
  PostApiV1FeedbackFeedbackidLangsMutationRequest,
  PostApiV1FeedbackFeedbackidLangsMutationResponse,
  PostApiV1FeedbackFeedbackidLangsPathParams,
} from "../../types/feedbackIdiomasController/PostApiV1FeedbackFeedbackidLangs.ts";
import { createFeedbackLangRequestViewModelSchema } from "../createFeedbackLangRequestViewModelSchema.ts";
import { feedbackLangViewModelSchema } from "../feedbackLangViewModelSchema.ts";

export const postApiV1FeedbackFeedbackidLangsPathParamsSchema = z.object({
  feedbackId: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1FeedbackFeedbackidLangsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1FeedbackFeedbackidLangs202Schema = z.lazy(
  () => feedbackLangViewModelSchema,
) as unknown as ToZod<PostApiV1FeedbackFeedbackidLangs202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1FeedbackFeedbackidLangs400Schema =
  z.any() as unknown as ToZod<PostApiV1FeedbackFeedbackidLangs400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1FeedbackFeedbackidLangs401Schema =
  z.any() as unknown as ToZod<PostApiV1FeedbackFeedbackidLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1FeedbackFeedbackidLangs404Schema =
  z.any() as unknown as ToZod<PostApiV1FeedbackFeedbackidLangs404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const postApiV1FeedbackFeedbackidLangs409Schema =
  z.any() as unknown as ToZod<PostApiV1FeedbackFeedbackidLangs409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1FeedbackFeedbackidLangs500Schema =
  z.any() as unknown as ToZod<PostApiV1FeedbackFeedbackidLangs500>;

export const postApiV1FeedbackFeedbackidLangsMutationRequestSchema = z.lazy(
  () => createFeedbackLangRequestViewModelSchema,
) as unknown as ToZod<PostApiV1FeedbackFeedbackidLangsMutationRequest>;

export const postApiV1FeedbackFeedbackidLangsMutationResponseSchema = z.lazy(
  () => postApiV1FeedbackFeedbackidLangs202Schema,
) as unknown as ToZod<PostApiV1FeedbackFeedbackidLangsMutationResponse>;
